import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import RequiredMark from '@elliemae/ds-form/RequiredMark';
import memoizeOne from 'memoize-one';
import { ResizeObserver } from 'resize-observer';
import styled from 'styled-components';
import Carousel from './Carousel.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import '@elliemae/ds-icons/ChevronRight';
import '@elliemae/ds-icons/ChevronLeft';
import '@elliemae/ds-button';
import './useResize.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var blockName = 'tabs-tab-bar';
var gradientWidth = 24;
var StyledTabWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-7sdovg-0"
})(["display:flex;flex:1;flex-wrap:nowrap;", ";"], function (_ref) {
  var flexibleTabsHeaders = _ref.flexibleTabsHeaders;
  return flexibleTabsHeaders ? '' : 'overflow-x: hidden';
});
var StyledTabList = aggregatedClasses('div')(blockName, 'list', function (_ref2) {
  var withCarousel = _ref2.withCarousel,
      flexibleTabsHeaders = _ref2.flexibleTabsHeaders,
      fixedTabsHeaders = _ref2.fixedTabsHeaders,
      isDSMobile = _ref2.isDSMobile,
      withLeftGradients = _ref2.withLeftGradients,
      withRightGradients = _ref2.withRightGradients;
  return {
    carousel: withCarousel,
    'flexible-table-headers': isDSMobile && flexibleTabsHeaders,
    'fixed-table-headers': isDSMobile && fixedTabsHeaders,
    'left-gradients': isDSMobile && flexibleTabsHeaders && withLeftGradients,
    'right-gradients': isDSMobile && flexibleTabsHeaders && withRightGradients
  };
}, {
  propsToRemoveFromFinalElement: ['withCarousel', 'flexibleTabsHeaders', 'fixedTabsHeaders', 'withLeftGradients', 'withRightGradients', 'isDSMobile']
});
var TabContainer = aggregatedClasses('button', {
  role: 'tab'
})(blockName, 'tab', function (_ref3) {
  var isActive = _ref3.isActive,
      showSeparator = _ref3.showSeparator,
      disabled = _ref3.disabled;
  return {
    active: isActive,
    separator: showSeparator,
    disabled: disabled
  };
});
var SelectionIndicator = aggregatedClasses('div')(blockName, 'selection-indicator');

var TabBar = /*#__PURE__*/function (_Component) {
  _inherits(TabBar, _Component);

  var _super = _createSuper(TabBar);

  function TabBar(_props) {
    var _this;

    _classCallCheck(this, TabBar);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (tabId, e) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          tabListRef = _assertThisInitialize.tabListRef,
          props = _assertThisInitialize.props;

      var onTabClick = props.onTabClick,
          flexibleTabsHeaders = props.flexibleTabsHeaders,
          isDSMobile = props.isDSMobile;

      if (isDSMobile && flexibleTabsHeaders) {
        var tabListDomEl = tabListRef.current;
        var el = e.target;
        var offsetLeft = el.offsetLeft;

        var _el$getBoundingClient = el.getBoundingClientRect(),
            elWidth = _el$getBoundingClient.width;

        var _tabListDomEl$getBoun = tabListDomEl.getBoundingClientRect(),
            listWidth = _tabListDomEl$getBoun.width;

        var extraSideSpace = listWidth - elWidth;
        var leftOffsetToCenter = extraSideSpace > 0 ? extraSideSpace / 2 : 0;
        var centeredLeftOffset = offsetLeft > leftOffsetToCenter ? offsetLeft - leftOffsetToCenter : 0;
        tabListDomEl.scrollTo({
          top: 0,
          left: centeredLeftOffset,
          behavior: 'smooth'
        });
      }

      e.preventDefault();
      onTabClick(tabId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (tabId, e, index) {
      var _this$props = _this.props,
          tabs = _this$props.tabs,
          handleDownArrow = _this$props.handleDownArrow,
          handleUpArrow = _this$props.handleUpArrow;

      if (e.keyCode === 39) {
        var _this$tabsRef;

        var nextTab = tabs[index + 1];
        if (!nextTab && handleDownArrow) handleDownArrow(e);
        if (!nextTab) return; // const { props } = nextTab
        // onTabClick(props.tabId)

        (_this$tabsRef = _this.tabsRef[index + 1]) === null || _this$tabsRef === void 0 ? void 0 : _this$tabsRef.focus();
      }

      if (e.keyCode === 37) {
        var _this$tabsRef2;

        var _nextTab = tabs[index - 1];
        if (!_nextTab && handleUpArrow) handleUpArrow(e);
        if (!_nextTab) return; // const { props } = nextTab
        // onTabClick(props.tabId)

        (_this$tabsRef2 = _this.tabsRef[index - 1]) === null || _this$tabsRef2 === void 0 ? void 0 : _this$tabsRef2.focus();
      }

      if (e.keyCode === 40 && handleDownArrow) {
        handleDownArrow(e);
      }

      if (e.keyCode === 38 && handleUpArrow) {
        handleUpArrow(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabsHeadersHorizontalScroll", debounce(function () {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          tabListRef = _assertThisInitialize2.tabListRef,
          props = _assertThisInitialize2.props;

      var flexibleTabsHeaders = props.flexibleTabsHeaders,
          isDSMobile = props.isDSMobile;

      if (isDSMobile && flexibleTabsHeaders) {
        var tabListDomEl = tabListRef.current;
        var scrollLeft = tabListDomEl.scrollLeft,
            scrollWidth = tabListDomEl.scrollWidth,
            clientWidth = tabListDomEl.clientWidth;

        var withLeftGradients = _this.shouldHaveLeftGradient(scrollLeft, gradientWidth);

        var withRightGradients = _this.shouldHaveRightGradient(scrollLeft, gradientWidth, clientWidth, scrollWidth);

        _this.setState({
          withLeftGradients: withLeftGradients,
          withRightGradients: withRightGradients
        });
      }
    }, 50));

    _defineProperty(_assertThisInitialized(_this), "renderTabs", memoizeOne(function (activeTab, tabs) {
      var showSeparator = _this.props.showSeparator;
      return React.Children.map(tabs, function (tab, index) {
        var _tab$props = tab.props,
            tabId = _tab$props.tabId,
            title = _tab$props.title,
            style = _tab$props.style,
            required = _tab$props.required,
            disabled = _tab$props.disabled;
        var isActive = activeTab === tabId;
        return [/*#__PURE__*/React.createElement(TabContainer, {
          key: tabId // eslint-disable-next-line no-return-assign
          ,
          ref: function ref(t) {
            _this.tabsRef[index] = t;

            if (index === 0 && _this.props.firstSubtabRef) {
              _this.props.firstSubtabRef.current = t;
            }

            if (index === tabs.length - 1 && _this.props.lastTabRef) {
              _this.props.lastTabRef.current = t;
            }
          },
          "aria-controls": tabId,
          "aria-selected": isActive,
          "aria-disabled": !!disabled,
          classProps: {
            isActive: isActive,
            showSeparator: showSeparator,
            disabled: disabled
          },
          "data-tab-id": tabId,
          id: "".concat(tabId, "-label"),
          onClick: function onClick(e) {
            if (!disabled) _this.handleTabClick(tabId, e, index);
          },
          onKeyDown: function onKeyDown(e) {
            if (!disabled) _this.handleKeyPress(tabId, e, index);
          },
          style: style,
          tabIndex: 0
        }, title, /*#__PURE__*/React.createElement(RequiredMark, {
          required: required
        }))];
      }, null);
    }));

    _this.tabListRef = /*#__PURE__*/React.createRef();
    _this.resizeObserver = new ResizeObserver(function () {
      return _this.setIndicatorStyle();
    });
    _this.state = {
      indicatorStyle: null,
      withLeftGradients: false,
      withRightGradients: false
    };
    _this.setIndicatorStyle = _this.setIndicatorStyle.bind(_assertThisInitialized(_this));
    _this.getIndicatorStyles = _this.getIndicatorStyles.bind(_assertThisInitialized(_this));
    _this.handleGradients = _this.handleGradients.bind(_assertThisInitialized(_this));
    _this.handleTabsHeadersHorizontalScroll = _this.handleTabsHeadersHorizontalScroll.bind(_assertThisInitialized(_this));
    _this.tabsRef = {};
    _this.setIndicatorStyle = _this.setIndicatorStyle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TabBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var showSelectionIndicator = this.props.showSelectionIndicator;
      this.resizeObserver.observe(this.tabListRef.current);

      if (showSelectionIndicator) {
        this.setIndicatorStyle();
      }

      window.addEventListener('resize', this.handleGradients);
      window.addEventListener('orientationchange', this.handleGradients);
      this.handleGradients();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          activeTab = _this$props2.activeTab,
          showSelectionIndicator = _this$props2.showSelectionIndicator;

      if (showSelectionIndicator && prevProps.activeTab !== activeTab) {
        this.setIndicatorStyle(activeTab);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.resizeObserver.unobserve(this.tabListRef.current);
      window.removeEventListener('resize', this.handleGradients);
      window.removeEventListener('orientationchange', this.handleGradients);
    }
  }, {
    key: "handleGradients",
    value: function handleGradients() {
      var _this$tabListRef$curr = this.tabListRef.current,
          scrollLeft = _this$tabListRef$curr.scrollLeft,
          scrollWidth = _this$tabListRef$curr.scrollWidth,
          clientWidth = _this$tabListRef$curr.clientWidth;
      var withLeftGradients = this.shouldHaveLeftGradient(scrollLeft, gradientWidth);
      var withRightGradients = this.shouldHaveRightGradient(scrollLeft, gradientWidth, clientWidth, scrollWidth);
      this.setState({
        withLeftGradients: withLeftGradients,
        withRightGradients: withRightGradients
      });
    }
  }, {
    key: "shouldHaveLeftGradient",
    value: function shouldHaveLeftGradient(scrollLeft, gWidth) {
      return Math.abs(scrollLeft) > gWidth;
    } // eslint-disable-next-line max-params

  }, {
    key: "shouldHaveRightGradient",
    value: function shouldHaveRightGradient(scrollLeft, gWidth, clientWidth, scrollWidth) {
      return Math.abs(scrollLeft) <= scrollWidth - (clientWidth + gWidth);
    }
  }, {
    key: "setIndicatorStyle",
    value: function setIndicatorStyle() {
      var _this2 = this;

      var activeTab = this.props.activeTab;
      setTimeout(function () {
        return _this2.setState({
          indicatorStyle: _this2.getIndicatorStyles(activeTab)
        });
      }, 100);
    }
  }, {
    key: "getActiveTabElement",
    value: function getActiveTabElement(activeTab) {
      var tabListEl = this.tabListRef.current;
      var tabSelector = "[data-tab-id=\"".concat(activeTab, "\"]");
      return tabListEl && tabListEl.querySelector(tabSelector);
    }
  }, {
    key: "isElementVisible",
    value: function isElementVisible(el, holder) {
      var _el$getBoundingClient2 = el.getBoundingClientRect(),
          left = _el$getBoundingClient2.left,
          right = _el$getBoundingClient2.right,
          width = _el$getBoundingClient2.width;

      var holderRect = holder.getBoundingClientRect();
      return left <= holderRect.left ? holderRect.left - left <= width : right - holderRect.right <= width;
    }
  }, {
    key: "getVisibleDimensions",
    value: function getVisibleDimensions(node, referenceNode) {
      var pos = node.getBoundingClientRect();
      var referencePos = referenceNode.getBoundingClientRect();
      return {
        width: Math.min(node.clientWidth, referencePos.left + referenceNode.clientWidth - pos.left, node.clientWidth - (referencePos.left - pos.left)),
        height: Math.min(node.clientHeight, referencePos.top + referenceNode.clientHeight - pos.top, node.clientHeight - (referencePos.top - pos.top))
      };
    }
  }, {
    key: "getIndicatorStyles",
    value: function getIndicatorStyles(activeTab) {
      var tabListEl = this.tabListRef.current;
      var withCarousel = this.props.withCarousel;
      var activeTabEl = this.getActiveTabElement(activeTab);
      if (!activeTabEl || !this.isElementVisible(activeTabEl, tabListEl)) return null;
      var clientHeight = activeTabEl.clientHeight,
          clientWidth = activeTabEl.clientWidth,
          offsetTop = activeTabEl.offsetTop,
          offsetLeft = activeTabEl.offsetLeft;

      var _activeTabEl$getBound = activeTabEl.getBoundingClientRect(),
          left = _activeTabEl$getBound.left;

      var leftOff = withCarousel ? Math.max(0, left - tabListEl.getBoundingClientRect().left) : offsetLeft;
      var width = withCarousel ? this.getVisibleDimensions(activeTabEl, tabListEl).width : clientWidth + 2;
      return {
        height: clientHeight,
        left: "".concat(Math.floor(leftOff), "px"),
        // using left and top for ie compatibility
        top: "".concat(Math.floor(offsetTop), "px"),
        width: width
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          id = _this$props3.id,
          tabs = _this$props3.tabs,
          activeTab = _this$props3.activeTab,
          renderCustomTabBar = _this$props3.renderCustomTabBar,
          withCarousel = _this$props3.withCarousel,
          isDSMobile = _this$props3.isDSMobile,
          flexibleTabsHeaders = _this$props3.flexibleTabsHeaders,
          fixedTabsHeaders = _this$props3.fixedTabsHeaders;
      var _this$state = this.state,
          indicatorStyle = _this$state.indicatorStyle,
          withLeftGradients = _this$state.withLeftGradients,
          withRightGradients = _this$state.withRightGradients;

      if (renderCustomTabBar) {
        return renderCustomTabBar({
          innerRef: this.tabListRef,
          withCarousel: withCarousel,
          tabsComponents: this.renderTabs(activeTab, tabs)
        });
      }

      var shouldUseCarousel = !isDSMobile && withCarousel;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTabList, {
        withCarousel: withCarousel,
        "aria-label": id,
        innerRef: this.tabListRef,
        role: "tablist",
        "data-testid": "tab-list",
        isDSMobile: isDSMobile,
        flexibleTabsHeaders: flexibleTabsHeaders,
        withLeftGradients: withLeftGradients,
        withRightGradients: withRightGradients,
        fixedTabsHeaders: fixedTabsHeaders,
        onScroll: this.handleTabsHeadersHorizontalScroll,
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(StyledTabWrapper, {
        isDSMobile: isDSMobile,
        flexibleTabsHeaders: flexibleTabsHeaders,
        fixedTabsHeaders: fixedTabsHeaders
      }, shouldUseCarousel ? /*#__PURE__*/React.createElement(Carousel, {
        onScroll: this.setIndicatorStyle
      }, this.renderTabs(activeTab, tabs)) : null, !shouldUseCarousel ? this.renderTabs(activeTab, tabs) : null, /*#__PURE__*/React.createElement(SelectionIndicator, {
        style: indicatorStyle
      }))));
    }
  }]);

  return TabBar;
}(Component);

TabBar.defaultProps = {
  showSelectionIndicator: true,
  showSeparator: false,
  isDSMobile: false
};
TabBar.propTypes = {
  /** Separator between tabs */
  showSeparator: PropTypes.bool,

  /** Blue border under selected tab */
  showSelectionIndicator: PropTypes.bool,

  /** Tab list id */
  id: PropTypes.string,

  /** Array of tabs */
  tabs: PropTypes.arrayOf(PropTypes.element).isRequired,

  /** Renders a custom tabbar */
  renderCustomTabBar: PropTypes.func,

  /** tabId of active tab */
  activeTab: PropTypes.string,

  /** on tab click callback */
  onTabClick: PropTypes.func,

  /** carousel behavior */
  withCarousel: PropTypes.bool,
  handleDownArrow: PropTypes.func,
  handleUpArrow: PropTypes.func,
  firstSubtabRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  lastTabRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),

  /** Whether or not it's a ds-tab from DSMobile tabs */
  isDSMobile: PropTypes.bool,

  /** DSMobile only flexible tabs mode */
  flexibleTabsHeaders: PropTypes.bool,

  /** DSMobile only fixed tabs mode */
  fixedTabsHeaders: PropTypes.bool
  /** Whether we are in mobile mode or not */

};

export default TabBar;
//# sourceMappingURL=TabBar.js.map
